<template>
  <tr >
    <td style="text-align: center;padding: 0px;"> {{index + 1}} </td>
    <td style="padding: 0px;">
      <select class="form-control" v-model="cr_dr" @change="cr_dr_changed" autofocus >
        <option value="1">Cr</option>
        <option value="-1">Dr</option>
      </select>
    </td>
    <td style="padding: 0px;">
      <select class="form-control" v-if="detail" v-model="detail.ledger_id" >
        <option v-for="ledger in ledgers" v-bind:value="ledger.id">
          {{ ledger.name }}
        </option>
      </select>
    </td>
    <td style="padding: 0px;">
      <input type="text" class="form-control" placeholder="Description" maxlength="100"  v-if="detail" v-model="detail.remarks" />
    </td>
    <td style="padding: 0px;">
      <input type="number" class="form-control text-right" min="0"  step="any" placeholder="0.00" v-if="detail" v-model="detail.credit"  @change="row_value_changed(index,4)"  :disabled="!(is_credit)"/>
    </td>
    <td style="padding: 0px;">
      <input type="number" class="form-control text-right" min="0"  step="any" placeholder="0.00" v-if="detail" v-model="detail.debit" @change="row_value_changed(index,5)" :disabled="is_credit"/>
    </td>
    <td style="padding: 0px;text-align: right;">
      <button type="button" class="btn border-warning text-warning-600 btn-flat btn-icon btn-rounded legitRipple btnRemoveRow" @click="removeRow()" tabindex="-1" ><i class="icon-eraser"></i></button>
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'JournalDetailRow',
    props:{
      ledgers:{
        type: Array,
        default: () => []
      },
      myrow: {
        type: Object,
        default: () => JSON.parse('{"id":0,"voucher_id":0,"idx":0,"adjust_type":0,"ledger_id":0,"debit":0,"credit":0,"remarks":"","ledger":{"id":0,"group_id":0,"name":"","alias":"","open_bal":0}}')
      },
      index: {
        type: Number,
        default: () => 0
      },
    },
    beforeMount () {
      this.detail = this.myrow;
      if (this.$data.detail.credit > 0) {
        this.$data.is_credit = true;
        this.$data.cr_dr = 1;
      }else{
        this.$data.is_credit = false;
        this.$data.cr_dr = -1;
      }
    },
    data() {
      return {
        cr_dr : 1,
        is_credit:true,
        detail : JSON.parse('{"id":0,"voucher_id":0,"idx":0,"adjust_type":0,"ledger_id":0,"debit":0,"credit":0,"remarks":"","ledger":{"id":0,"group_id":0,"name":"","alias":"","open_bal":0}}'),
      }
    },
    mounted(){

    },
    methods:{
      removeRow(){
        this.$emit('onRemoveRow', this.$props.index );
      },
      cr_dr_changed(){
        this.$data.is_credit = this.$data.cr_dr == 1;
      },
      row_value_changed(rowIndex, colIndex){
        this.$emit('onrow_change',rowIndex, colIndex);
      }
    }
  }
</script>

<style scoped>
input:focus {
  background: #feff00;

}

textarea:focus {
  background: #feff00;

}

select:focus {
  background: #feff00;
}

button:focus {
  background: #feff00;
  color: #0a0a0a!important;
}
</style>
